import React from "react";
import { useReveal } from "../../lib/hooks";

/**
 * Fades + lifts its children in the first time they enter the viewport.
 * Uses one shared IntersectionObserver, and only animates opacity/transform.
 */
const Reveal = ({ as: Tag = "div", delay = 0, className = "", children, ...rest }) => {
  const ref = useReveal(delay);
  return (
    <Tag ref={ref} className={`reveal ${className}`.trim()} {...rest}>
      {children}
    </Tag>
  );
};

export default Reveal;
